import {Brick, registerBrick} from 'olympe';
import MSGraphTask from './DM_MSGraphTask';

export default class CodedCreateTaskPayload extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} taskObj
     * @param {function()} forwardEvent
     * @param {function(*)} setOutput
     */
    update ($, [taskObj], [forwardEvent, setOutput]) {
        const title = taskObj.getTitle();
        const planId = taskObj.getPlanId();
        const bucketId = taskObj.getBucketId();
        const dueDateTime = taskObj.getDueDateTime();
        const assignedTo = taskObj.getAssignedTo();
        const percentComplete = taskObj.getPercentComplete();
        let assignedToList = [];

        if (typeof assignedTo === 'string') {
            assignedToList = assignedTo.split(',');
        }

        assignedToList = assignedToList.length > 0 && assignedToList.reduce((object, user) => {
            object[user] = {
                "@odata.type": "#microsoft.graph.plannerAssignment",
                "orderHint": " !"
            };
            return object;

        }, {});

        const taskPayload = {
            title,
            planId,
            bucketId,
            dueDateTime: dueDateTime.toISOString(),
            percentComplete,
            assignments: {
                ...assignedToList
            }
        };

        setOutput(taskPayload);
        forwardEvent();
    }
}

registerBrick('018de5959b37ce52df7c', CodedCreateTaskPayload);
